module.exports = __webpack_public_path__ + "img/video-cover__pavlenko.4114eb2a.jpg";